import { render, staticRenderFns } from "./sso-mapping-section.vue?vue&type=template&id=5b360faa&scoped=true"
import script from "./sso-mapping-section.vue?vue&type=script&lang=js"
export * from "./sso-mapping-section.vue?vue&type=script&lang=js"
import style0 from "./sso-mapping-section.vue?vue&type=style&index=0&id=5b360faa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b360faa",
  null
  
)

export default component.exports